import { ChatProvider } from "@arcadeai/ui-kit/chat/context";
import { useSuspenseQuery } from "@tanstack/react-query";
import {
  createFileRoute,
  Outlet,
  useMatch,
  useRouter,
} from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import { sessionQueryOptions } from "@/lib/auth-client";
import { BFF_URL } from "@/lib/const";
import { useOrgProjectRouteContext } from "@/lib/org-project-context/hooks";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat"
)({
  beforeLoad: (ctx) => requireProjectPermission(ctx, PROJECT.tools.execute),
  component: PlaygroundChatLayout,
  loader: () => ({
    crumb: "Chat",
  }),
});

function PlaygroundChatLayout() {
  const router = useRouter();
  const { organizationId, projectId } = useOrgProjectRouteContext();
  const { data: session } = useSuspenseQuery(sessionQueryOptions);
  const viewerId = session?.user?.id ?? "";

  const chatIdMatch = useMatch({
    from: "/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/$chatId",
    shouldThrow: false,
  });
  const chatId = chatIdMatch?.params.chatId;

  return (
    <ChatProvider
      baseUrl={BFF_URL}
      initialChatId={chatId}
      key={`${organizationId}:${projectId}`}
      onAuthError={() => router.invalidate()}
      onChatPersisted={(persistedChatId) => {
        const chatBasePath = router.buildLocation({
          to: "/orgs/$organizationId/projects/$projectId/playground/chat",
          params: { organizationId, projectId },
        }).href;

        if (!window.location.pathname.startsWith(chatBasePath)) {
          return;
        }

        const url = router.buildLocation({
          to: "/orgs/$organizationId/projects/$projectId/playground/chat/$chatId",
          params: { organizationId, projectId, chatId: persistedChatId },
        }).href;
        window.history.replaceState(window.history.state, "", url);
      }}
      organizationId={organizationId}
      projectId={projectId}
      viewerId={viewerId}
    >
      <Outlet />
    </ChatProvider>
  );
}
